import { Pipe, PipeTransform } from '@angular/core';
import { Supplier } from '../../classes/supplier';

@Pipe({
  name: 'supplierEmailFilter',
  pure: false
})
export class SupplierEmailFilterPipe implements PipeTransform {

  transform(supplierList: Array<Supplier>, filterValue: string): any {
    if (!supplierList || !filterValue) {
      return supplierList;
    }
    const normalizedFilterValue = filterValue.toLowerCase().trim();
    return supplierList.filter(supplier =>
      (supplier.Email || '').toLowerCase().indexOf(normalizedFilterValue) !== -1
    );
  }

}
